import axios from "axios"

import { apiDomain } from "../../store/constants"

const Request = {
    getSpaceRequestsList (data) {
        return axios({
            url: apiDomain + `api/area-management`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    getSpaceRequestsListById (data) {
        return axios({
            url: apiDomain + `api/area-management/${data.id}`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    createSpaceRequestsForm (data) {
        return axios({
            url: apiDomain + `api/area-management/master-data`,
            method: 'GET',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    saveSpaceRequestsForm (data) {
        return axios({
            url: apiDomain + `api/area-management`,
            method: 'POST',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    updateSpaceRequestsForm (data) {
        return axios({
            url: apiDomain + `api/area-management/${data.id}`,
            method: 'PUT',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    deleteSpaceRequestsForm (id) {
        return axios({
            url: apiDomain + `api/area-management/${id}`,
            method: 'DELETE',
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    getSpaceRequestsAll (data) {
        return axios({
            url: apiDomain + `api/area-management/without-draft`,
            method: 'GET',
            params: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },  
    formConsider (data) {
        return axios({
            url: apiDomain + `api/area-group`,
            method: 'POST',
            data: data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    getEvaluateAreaList(payload) {
        return axios({
          url: apiDomain + "api/area-group",
          method: "GET",
          params:payload
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      changeStatusSpiderChart(payload) {
        return axios({
          url: apiDomain + "api/spider-chart/change-status",
          method: "POST",
          params:payload
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      getSpiderChartPrepareData(id) {
        return axios({
          url: apiDomain + `api/spider-chart/create/${id}`,
          method: "GET",
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      sendToConsiderApprove(id) {
        return axios({
          url: apiDomain + `api/area-group/change-status/${id}`,
          method: "GET",
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      storeSpiderChart(payload) {
        return axios({
          url: apiDomain + "api/spider-chart",
          method: "POST",
          data: payload
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      updateSpiderChart(data) {
        return axios({
          url: apiDomain + `api/spider-chart/${data.id}`,
          method: "PUT",
          data: data
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        });
      },
      getSpiderChartById(data) {
        return axios({
          url: apiDomain + `api/spider-chart/${data.id}/edit`,
          method: "GET",
          params: data
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        })
      },
      onStamp(id) {
        return axios({
          url: apiDomain + `api/area-management/exit/${id}`,
          method: "PUT",
        }).catch((e) => {
          console.log("Catch error \n", e.message);
          return e.response;
        })
      }
}

export default Request